import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { getIconColor } from "@/src/services/iconService";

const IconWorkCertificate = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m129.84,111.17c3.13,0,5.67-2.54,5.67-5.67v-43.07c0-15.56-11.92-23.7-23.7-23.7s-23.7,8.14-23.7,23.7v43.07c0,3.13,2.54,5.67,5.67,5.67s5.67-2.54,5.67-5.67v-18.56h24.73v18.56c0,3.13,2.54,5.67,5.67,5.67Zm-30.4-35.57v-13.17c0-11.77,10.3-12.36,12.36-12.36s12.36.6,12.36,12.36v13.17h-24.73Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m166.96,44.08c-3.13,0-5.67,2.54-5.67,5.67v12.36h-12.36c-3.13,0-5.67,2.54-5.67,5.67s2.54,5.67,5.67,5.67h12.36v12.36c0,3.13,2.54,5.67,5.67,5.67s5.67-2.54,5.67-5.67v-12.36h12.36c3.13,0,5.67-2.54,5.67-5.67s-2.54-5.67-5.67-5.67h-12.36v-12.36c0-3.13-2.54-5.67-5.67-5.67Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m72.52,171.3h125.12c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-125.12c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m72.52,197.47h125.12c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-125.12c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m68.26,140.87c0,2.35,1.9,4.25,4.25,4.25h125.12c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-125.12c-2.35,0-4.25,1.9-4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m72.52,223.65h125.12c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-125.12c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m242.36,252.66V18.39c0-6.97-5.68-12.64-12.65-12.64H41.34c-6.97,0-12.64,5.67-12.64,12.64v43.09c0,2.35,1.9,4.25,4.25,4.25s4.25-1.9,4.25-4.25V18.39c0-2.28,1.86-4.14,4.14-4.14h188.37c2.29,0,4.15,1.86,4.15,4.14v234.27c0,2.28-1.86,4.14-4.14,4.14H41.35c-2.29,0-4.15-1.86-4.15-4.14V84.31c0-2.35-1.9-4.25-4.25-4.25s-4.25,1.9-4.25,4.25v168.35c0,6.97,5.68,12.64,12.65,12.64h188.37c6.97,0,12.64-5.67,12.64-12.64Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m258.65,34.7c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25,4.15,1.86,4.15,4.14v234.27c0,2.28-1.86,4.14-4.14,4.14H70.3c-2.29,0-4.15-1.86-4.15-4.14s-1.9-4.25-4.25-4.25-4.25,1.9-4.25,4.25c0,6.97,5.68,12.64,12.65,12.64h188.37c6.97,0,12.64-5.67,12.64-12.64V47.34c0-6.97-5.68-12.64-12.65-12.64Z"
      />
    </SvgIcon>
  );
};

export default IconWorkCertificate;
